














































































































import Vue from "vue";
import { AxiosResponse } from "axios";
import { ValidationObserver, extend } from "vee-validate";
import store from "@/store";
// api
import * as settingApi from "@/features/setting/axios";
// component
import PageTitle from "@/commons/components/PageTitle.vue";
import NewUserCard from "@/features/setting/components/newUserCard.vue";
import EditUserCard from "@/features/setting/components/editUserCard.vue";
// enum
import { AuthorityEnum } from "@/features/setting/enums/Authority";
// types
import { DataTableHeader } from "vuetify/types";
import {
  LoginUser,
  User,
  Publisher,
  AddUserBody,
  UpdateUserBody,
  UserResponse,
  UsersResponse,
  PublishersResponse,
} from "@/features/setting/types";
import { Enum } from "@/commons/enums/Type";
// util
import * as notifyUtil from "@/commons/utils/notifyUtil";

extend("passwordSize", {
  validate(value) {
    return value.length >= 8 && value.length <= 32;
  },
});
extend("required_upper", {
  validate(value) {
    const upperCaseRegex = new RegExp(/[A-Z]/);
    return upperCaseRegex.test(value);
  },
});
extend("required_lower", {
  validate(value) {
    const lowerCaseRegex = new RegExp(/[a-z]/);
    return lowerCaseRegex.test(value);
  },
});
extend("required_num", {
  validate(value) {
    const numRegex = new RegExp(/[0-9]/);
    return numRegex.test(value);
  },
});
extend("emojiSyntax", {
  validate(value) {
    const emojiRegex = new RegExp(require("emoji-regex"));
    return !emojiRegex.test(value);
  },
});

export default Vue.extend({
  components: {
    "page-title": PageTitle,
    "validation-observer": ValidationObserver,
    "new-user-card": NewUserCard,
    "edit-user-card": EditUserCard,
  },
  data() {
    return {
      newUserDialog: false,
      editUserDialog: false,
      nameInput: "" as string,
      emailInput: "" as string,
      passwordInput: "" as string,
      confirmedPasswordInput: "" as string,
      authority: [] as Enum[],
      authorityInput: null as number | null,
      publishersInput: [] as number[],
      publishers: [] as Publisher[],
      users: [] as User[],
      editingUserId: null as number | null,
      formSearchValue: "" as string,
      searchValue: "" as string,
      recentModal: "" as string, // 直近で使用したモーダル(New User or Edit User)を格納
      loading: true as boolean,
      index: 1 as number,
    };
  },
  computed: {
    loginUser(): LoginUser {
      return store.getters["auth/getLoginUser"];
    },
    usersTableHeaders(): DataTableHeader[] {
      return [
        {
          text: String(this.$t("settings.tableHeader.name")),
          value: "userName",
          width: "45%",
        },
        {
          text: String(this.$t("settings.tableHeader.email")),
          value: "email",
          width: "35%",
        },
        {
          text: String(this.$t("settings.tableHeader.userType")),
          value: "userType",
          width: "15%",
        },
        {
          text: "",
          value: "action",
          align: "end",
          width: "5%",
        },
      ];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async clickNewUser() {
      // 直近で使用したモーダルが Edit User であれば inputs をクリア
      if (this.recentModal === "Edit User") {
        this.clearInputs();
      }
      // ログインユーザーに紐づくパブリッシャー一覧を取得
      if (this.loginUser?.agencyId !== null && this.loginUser?.agencyId !== undefined) {
        await settingApi
          .getAgenciesPublishers(this.loginUser?.agencyId)
          .then((response: AxiosResponse<PublishersResponse>) => {
            this.publishers = response.data.publishers;
          })
          .catch(error => {
            if (error.response.status === 401) {
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
              this.$router.push({ name: "Login" });
            } else
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.publishers"));
          });
      } else if (this.loginUser?.clientId !== null && this.loginUser?.clientId !== undefined) {
        await settingApi
          .getClientsPublishers(this.loginUser?.clientId)
          .then((response: AxiosResponse<PublishersResponse>) => {
            this.publishers = response.data.publishers;
          })
          .catch(error => {
            if (error.response.status === 401) {
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
              this.$router.push({ name: "Login" });
            } else
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.publishers"));
          });
      } else {
        notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.publishers"));
      }
      // ログインユーザーのユーザータイプによって選択できる権限を絞り込む
      this.setAuthorityByUserType(this.loginUser?.type);
      this.newUserDialog = true;
      this.recentModal = "New User";
    },
    async clickEditUser(user: User) {
      // 直近で使用したモーダルが New User であれば inputs をクリア
      if (this.recentModal === "New User") {
        this.clearInputs();
      }
      // パラメータで受け取ったユーザー情報
      let usersAgencyId = null;
      let usersClientId = null;
      // パラメータで受け取ったユーザーの可視状態にあるパブリッシャー一覧取得
      await settingApi
        .getUser(user.userId)
        .then((response: AxiosResponse<UserResponse>) => {
          this.nameInput = response.data.user.name;
          this.emailInput = response.data.user.email;
          this.authorityInput = response.data.user.type;
          usersAgencyId = response.data.user.agencyId;
          usersClientId = response.data.user.clientId;
          this.publishersInput = response.data.publisherList.map(value => value.id);
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.users"));
        });
      // パラメータで受け取ったユーザーに紐づくパブリッシャー一覧取得
      if (usersAgencyId !== null) {
        await settingApi
          .getAgenciesPublishers(usersAgencyId)
          .then((response: AxiosResponse<PublishersResponse>) => {
            this.publishers = response.data.publishers;
          })
          .catch(error => {
            if (error.response.status === 401) {
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
              this.$router.push({ name: "Login" });
            } else
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.publishers"));
          });
      } else if (usersClientId !== null) {
        await settingApi
          .getClientsPublishers(usersClientId)
          .then((response: AxiosResponse<PublishersResponse>) => {
            this.publishers = response.data.publishers;
          })
          .catch(error => {
            if (error.response.status === 401) {
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
              this.$router.push({ name: "Login" });
            } else
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.publishers"));
          });
      } else {
        notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.publishers"));
      }
      this.setAuthorityByUserType(user.userType);
      this.editingUserId = user.userId;
      this.editUserDialog = true;
      this.recentModal = "Edit User";
    },
    async clickSaveOnNewUserDialog() {
      (this.$refs.newUser as InstanceType<typeof ValidationObserver>)
        .validate()
        .then(async (success: boolean) => {
          // バリデーション通過失敗時の処理
          if (!success) {
            return;
          }

          // 新規ユーザー作成処理
          const addUserBody: AddUserBody = {
            name: this.nameInput,
            email: this.emailInput,
            password: this.passwordInput,
            userType: String(this.authorityInput),
            publisherList: this.publishersInput,
          };
          await settingApi
            .addUser(addUserBody)
            .then(() => {
              notifyUtil.notifySuccessMessage(this.$t("settings.notify.success.save"));
              this.clearInputs();
              // TODO: [Vue warn]: Avoid mutating a prop directly が発生しているため修正が必要
              (this.$refs.newUserCard as InstanceType<typeof NewUserCard>).confirmedPasswordInput =
                "";

              // 更新内容を反映するためにデータをフェッチ
              this.fetchData();
              // ダイアログを閉じる
              this.newUserDialog = false;
            })
            .catch(error => {
              if (error.response.status === 401) {
                notifyUtil.notifyErrorMessage(
                  this.$t("general.notify.error.request.sessionExpired")
                );
                this.$router.push({ name: "Login" });
              } else notifyUtil.notifyErrorMessage(this.$t("settings.notify.error.failedSave"));
            });
        });
    },
    async clickSaveOnEditUserDialog() {
      (this.$refs.editUser as InstanceType<typeof ValidationObserver>)
        .validate()
        .then(async (success: boolean) => {
          // バリデーション通過失敗時の処理
          if (!success) {
            return;
          }

          // ユーザー更新処理
          const addUserBody: UpdateUserBody = {
            name: this.nameInput,
            userType: String(this.authorityInput),
            publisherList: this.publishersInput,
          };
          await settingApi
            .updateUser(addUserBody, this.editingUserId)
            .then(() => {
              notifyUtil.notifySuccessMessage(this.$t("settings.notify.success.save"));
              this.clearInputs();

              // 更新内容を反映するためにデータをフェッチ
              this.fetchData();
              // ダイアログを閉じる
              this.editUserDialog = false;
            })
            .catch(error => {
              if (error.response.status === 401) {
                notifyUtil.notifyErrorMessage(
                  this.$t("general.notify.error.request.sessionExpired")
                );
                this.$router.push({ name: "Login" });
              } else notifyUtil.notifyErrorMessage(this.$t("settings.notify.error.failedSave"));
            });
        });
    },
    clickCancelOnNewUserDialog() {
      this.newUserDialog = false;
    },
    clickCancelOnEditUserDialog() {
      this.editUserDialog = false;
    },
    clearInputs() {
      this.nameInput = "";
      this.emailInput = "";
      this.passwordInput = "";
      this.confirmedPasswordInput = "";
      this.authority.length = 0;
      this.authorityInput = null;
      this.publishers.length = 0;
      this.publishersInput.length = 0;
      this.editingUserId = null;
    },
    isMaster(user: LoginUser | null): boolean {
      return AuthorityEnum.checkMasterByValue(user?.type);
    },
    isFlux(userType: number | null): boolean {
      return AuthorityEnum.checkFluxByValue(userType);
    },
    isAgency(userType: number | null): boolean {
      return AuthorityEnum.checkAgencyByValue(userType);
    },
    isClient(userType: number | null): boolean {
      return AuthorityEnum.checkClientByValue(userType);
    },
    displayUserTypeById(userType: number): string | undefined {
      return AuthorityEnum.getByValue(userType)?.text;
    },
    setAuthorityByUserType(userType: number | null | undefined) {
      this.authority.length = 0;
      if (userType === null || userType === undefined) {
        return;
      }

      if (AuthorityEnum.checkFluxByValue(userType)) {
        this.authority.push(AuthorityEnum.FLUX_MASTER);
        this.authority.push(AuthorityEnum.FLUX_MEMBER);
      } else if (AuthorityEnum.checkAgencyByValue(userType)) {
        this.authority.push(AuthorityEnum.AGENCY_MASTER);
        this.authority.push(AuthorityEnum.AGENCY_MEMBER);
      } else if (AuthorityEnum.checkClientByValue(userType)) {
        this.authority.push(AuthorityEnum.CLIENT_MASTER);
        this.authority.push(AuthorityEnum.CLIENT_MEMBER);
      }
    },
    usersFilter(value: string | undefined | null, search: string | null, item: User): boolean {
      if (item.userName === null) item.userName = "";
      return value != null && search != null && item.userName.includes(search);
    },
    execSearch() {
      this.index = 1;
      this.searchValue = this.formSearchValue;
    },
    clearSearch() {
      this.index = 1;
      this.searchValue = "";
    },
    async fetchData() {
      // loading状態にする
      this.loading = true;

      // ログインユーザーに紐づくユーザー一覧を取得
      await settingApi
        .getUsers()
        .then((response: AxiosResponse<UsersResponse>) => {
          const myAccountIndex = response.data.users.findIndex((account: User) => {
            return account.email === this.loginUser.email;
          });
          const myAccount = response.data.users[myAccountIndex] as User;

          // 自身のユーザー情報より後ろの項目を保管して全体リストから自身のユーザー情報以降のリストを一旦切り捨てる
          const latterList = response.data.users.splice(myAccountIndex + 1) as User[];
          response.data.users.splice(myAccountIndex);

          // 保管したリストを結合して自身のユーザー情報のみ抜き出したリストを生成し、先頭に自身のユーザー情報を追加
          this.users = response.data.users.concat(latterList);
          this.users.splice(0, 0, myAccount);
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.users"));
        });

      // 全てのデータが更新された時点でloading完了
      this.loading = false;
    },
  },
  watch: {
    newUserDialog() {
      // ユーザー作成ダイアログが閉じたタイミングでバリデーションリセット
      if (this.newUserDialog)
        (this.$refs.newUser as InstanceType<typeof ValidationObserver>).reset();
    },
    editUserDialog() {
      // ユーザー編集ダイアログが閉じたタイミングでバリデーションリセット
      if (this.editUserDialog)
        (this.$refs.editUser as InstanceType<typeof ValidationObserver>).reset();
    },
  },
});
